import { useState } from "react";
import { Box, Flex, Container, Heading, Text, Button } from "@chakra-ui/react";
import TitleSpoleto from "../Title";
import SubTitle from "../SubTitle";
import {
  downloadFileHelper,
  disableBodyScroll,
  enableBodyScroll,
} from "../../utils";
import { createPortal } from "react-dom";
import GaleryCourtine from "../GaleryCourtine";

const ContestTheme = () => {
  const [show, setShow] = useState(false);

  const downloadTemplate = () => {
    const url = "/assets/files/spoleto_concurso_pratos_2022_template.pdf";
    return downloadFileHelper(url, "spoleto_concurso_pratos_2022_template.pdf");
  };

  const onClose = () => {
    enableBodyScroll();
    setShow(false);
  };

  const showGallery = () => {
    if (!show) return null;
    let modalWrapper = document.querySelector(".gallery-wrapper");

    if (!modalWrapper) {
      modalWrapper = document.createElement("div");
      modalWrapper.className = "gallery-wrapper";
    }

    document.body.appendChild(modalWrapper);
    disableBodyScroll();
    return createPortal(<GaleryCourtine onClose={onClose} />, modalWrapper);
  };

  const openGallery = () => {
    setShow(true);
  };

  return (
    <>
      <Box id="tema" className="tema-do-concurso" py={8} pb={16}>
        <Container maxW="container.xl" d={["block", null, "none"]}>
          <Box
            w="100%"
            bg="rgba(0, 0, 0, 0.9);"
            py={8}
            pb="100px"
            px={10}
            pos="relative"
          >
            <Box>
              <TitleSpoleto textAlign="center" color="#FDF6DC">
                ESTAMPAS DA <br /> NATUREZA
              </TitleSpoleto>
              <SubTitle mt={1}>Um concurso naturalmente artístico</SubTitle>
            </Box>
            <Heading
              color="#FCF3DB"
              textAlign="left"
              fontSize="18px"
              mt="50px"
              fontFamily="FiraSansRegular"
            >
              Chegou a hora!
            </Heading>
            <Flex pb="50px" w="100%" maxW="100%" justifyContent="flex-start">
              <Text
                color="#FCF3DB"
                textAlign="left"
                fontSize="18px"
                lineHeight="22px"
                fontFamily="FiraSansRegular"
              >
                O concurso mais querido do Brasil tá de volta e já ansioso pra
                conhecer as ilustrações da nossa nova Coleção. <br />
                <br />
                Então, se a arte faz parte da sua natureza, bora se inscrever!
                Aliás, quando falamos “da sua natureza" estamos sendo literais;
                plantas, mares, pedras, animais e mais tudo que vem da nossa
                natureza é inspiração primária para uma arte existir. E é isso
                que queremos na sua ilustração deste ano! <br /> <br />
                Amplie sua conexão com o meio ambiente para se inspirar ao
                máximo e produzir o prato com a mais linda Estampa da Natureza.
              </Text>
            </Flex>
            {/* <Box
              w="100%"
              pos="absolute"
              left="50%"
              right="50%"
              bottom="-23px"
              transform="translateX(-50%)"
            >
              <Button
                mt={8}
                bg="#331F12"
                color="#F5B241"
                fontWeight="normal"
                borderRadius="5px"
                width="100%"
                maxWidth="70%"
                h="50px"
                fontSize="20px"
                mb={4}
                _hover={{
                  backgroundColor: "#331F12",
                  color: "#F5B241",
                }}
                _active={{
                  outline: "3px solid #F5B241",
                }}
                onClick={openGallery}
              >
                Inspire-se
              </Button>
              <Button
                bg="#F5B241"
                color="#331F12"
                fontWeight="normal"
                borderRadius="5px"
                width="100%"
                maxWidth="70%"
                h="50px"
                fontSize="20px"
                _hover={{
                  backgroundColor: "#F5B241",
                  color: "#331F12",
                }}
                _active={{
                  outline: "3px solid #331F12",
                }}
                onClick={downloadTemplate}
              >
                Baixar o template
              </Button>
            </Box> */}
          </Box>
        </Container>
        <Container maxW="container.xl" d={["none", null, "block"]}>
          <Box w="100%" bg="rgba(0, 0, 0, 0.9);" py={8} px={10} pos="relative">
            <Box>
              <TitleSpoleto textAlign="center" color="#FDF6DC">
                {" "}
                ESTAMPAS DA NATUREZA
              </TitleSpoleto>
              <SubTitle mt={1}>Um concurso naturalmente artístico</SubTitle>
            </Box>
            <Heading
              color="#FCF3DB"
              textAlign="center"
              fontSize={["50px", null, null, null, "72px"]}
              mt="70px"
              mb="30px"
              fontFamily="JosefinLightItalic"
            >
              Chegou a hora!
            </Heading>
            <Flex
              pb="150px"
              w="100%"
              maxW="50%"
              mx="auto"
              justifyContent="center"
            >
              <Text
                float="right"
                color="#FCF3DB"
                textAlign="center"
                fontSize="18px"
                lineHeight="22px"
                mt={10}
                fontFamily="FiraSansRegular"
              >
                O concurso mais querido do Brasil tá de volta e já ansioso pra
                conhecer as ilustrações da nossa nova Coleção. <br />
                <br />
                Então, se a arte faz parte da sua natureza, bora se inscrever!
                Aliás, quando falamos “da sua natureza" estamos sendo literais;
                plantas, mares, pedras, animais e mais tudo que vem da nossa
                natureza é inspiração primária para uma arte existir. E é isso
                que queremos na sua ilustração deste ano! <br /> <br />
                Amplie sua conexão com o meio ambiente para se inspirar ao
                máximo e produzir o prato com a mais linda Estampa da Natureza.
              </Text>
            </Flex>
            {/* <Box
              pos="absolute"
              left="50%"
              right="50%"
              bottom="-35px"
              maxW={[null, null, "50%", "35%"]}
              w="100%"
            >
              <Button
                bg="#331F12"
                color="#F5B241"
                fontWeight="normal"
                borderRadius="5px"
                transform="translateX(-50%)"
                width="100%"
                minWidth="100%"
                h={["50px", null, "70px"]}
                fontSize={["20px", null, "32px"]}
                mb={4}
                _hover={{
                  backgroundColor: "#0A4330",
                  color: "#F5B241",
                }}
                onClick={openGallery}
              >
                Inspire-se
              </Button>
              <Button
                bg="#F5B241"
                color="#331F12"
                fontWeight="normal"
                borderRadius="5px"
                transform="translateX(-50%)"
                minWidth="100%"
                width="100%"
                h={["50px", null, "70px"]}
                fontSize={["20px", null, "32px"]}
                _hover={{
                  backgroundColor: "#F5B241",
                  color: "#0A4330",
                }}
                onClick={downloadTemplate}
              >
                Baixar o template
              </Button>
            </Box> */}
          </Box>
        </Container>
        {showGallery()}
      </Box>
    </>
  );
};
export default ContestTheme;
